import { Box, styled } from "@mui/material";

export const StyledAddImage = styled(Box)(({ theme }) => ({
  width: "80rem",
  height: "50rem",
  overflow: "hidden",
  position: "relative",
  background: theme.contrast.lighter,
  display: "flex",
  justifyContent: "center",
  ".camera": {
    width: "100%",
    height: "100%",
  },
  ".captureBtn": {
    width: "3rem",
    height: "3rem",
    borderRadius: "100px",
    border: `5px solid ${theme.color.main}`,
    position: "absolute",
    zIndex: "99",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bottom: "1rem",
    cursor: "pointer",
    ".captureCircle": {
      width: "2.5rem",
      height: "2.5rem",
      borderRadius: "100px",
      background: theme.color.main,
    },
    "&:hover": {
      borderColor: theme.color.dark,
      ".captureCircle": {
        background: theme.color.dark,
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
    width: "70rem",
    height: "40rem",
  },
}));
